export default [
    {
        name: 'listarTarefasContabilidade',
        path: '/contabilidade/tarefas',
        alias: '/contabilidade/tarefas/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarTarefasContabilidade',
        path: '/contabilidade/tarefas/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'copiarTarefasContabilidade',
        path: '/contabilidade/tarefas/adicionar/:id',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'editarTarefasContabilidade',
        path: '/contabilidade/tarefas/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        name: 'visualizarTarefasContabilidade',
        path: '/contabilidade/tarefas/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]
